import {Link, useParams} from 'react-router-dom';
import {useEffect} from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import './index.scss';
export default function RequestAccess() {
  const {id, status, pk_code, token_user} = useParams();
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const token = Cookies.get('token');
  const handleRequestAccess = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/auth/request-access-approval`,
        {
          staff_id: id,
          status: status,
          pk_code: pk_code,
          token_user: token_user,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id && status) handleRequestAccess();
  }, [id, status]);
  return (
    <div className='ra_ctr'>
      <h1
        className={`ra_title`}
        style={{
          color: status === 'approved' ? '#4CAF50' : '#F44336',
        }}
      >
        Request Access
      </h1>
      <p
        className='ra_status'
        style={{
          color: status === 'approved' ? '#4CAF50' : '#F44336',
        }}
      >
        {status}
      </p>
      <Link className='ra_btn' to={token ? '/' : '/login'}>
        {token ? 'Go to Dashboard' : 'Go to Login'}
      </Link>
    </div>
  );
}
